angular.module('gym.subscription', []).config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.subscription', {
    url: '/subscription',
    abstract: true,
    template: '<ui-view>'
  }).state('gym.subscription.tab', {
    url: '/:tab',
    template: require('templates/gyms/subscription/subscription.html.slim'),
    resolve: {
      tabs: function() {
        return ['subscriptions', 'billings', 'invoices'];
      },
      validTab: ["$stateParams", "$state", "tabs", function($stateParams, $state, tabs) {
        if (tabs.indexOf($stateParams.tab) === -1) {
          return $state.go('gym.subscription.tab', {
            tab: 'subscriptions'
          }, {
            location: 'replace'
          });
        }
        return true;
      }]
    }
  });
}]);
